<template>
  <div class="service-card-wrap" :class="from=='10901'||from=='10904'?'service-card-wrap' : 'service-card-wrapTwo' " v-if="compNo == 'BTLH'">
    <div>
      <div class="zskf">专属客服</div>
      <div class="triangle-bottomleft"/>
    </div>

    <van-cell style="margin-top: 5px; margin-bottom: 0px; padding: 0px 10px; z-index: 1; border-radius: 10px;">
      <van-row
        type="flex"
        align="center"
        class="kflist"
      >
        <van-col
          span="4"
          style="line-height: initial;"
          class="flexbox kflist"
        >
          <img :src="serviceData.photo? serviceData.photo : defkf" class="profile">
        </van-col>
        <van-col span="14" style="padding-left: 15px">
          <p class="nameZskf">{{ serviceData.userName }}</p>
          <p class="nameZskf">{{ serviceData.msg }}</p>
          <!-- <p class="typename">{{ user.userName }}   {{ user.phone }}</p> -->
          <!-- <p class="typename">{{nmap[kf_item.productType]['adv']}}</p> -->
        </van-col>
        <van-col span="6" class="flexbox" style="height: 80px; justify-content: flex-end">
          <img :src="kf" class="imageStyle" @click="call(serviceData.phone)">
          <img :src="weChat" class="imageStyle" style="margin-left: 10px" @click="toWeChat(serviceData.url)">
        </van-col>
      </van-row>
    </van-cell>
  </div>
</template>
<script>
import { Icon, Cell, Image as VanImage, Tag } from 'vant'
import kf from 'Components/Dynamic/btlh/images/service/kfNew.png'
import weChat from 'Components/Dynamic/btlh/images/service/weChatNew.png'
import defkf from "Components/Dynamic/btlh/images/service/defkf2.png";
import {isAndroid, isH5, isIOS, openWebview} from "CommonUtils/plus";
import {localget} from "Utils/storage";
import serviceData  from "Components/ServiceVipList/serviceData.json"

export default {
  name: "blService",
  components: {
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [VanImage.name]: VanImage,
    [Tag.name]: Tag,
  },
  data() {
    return {
      kf,
      weChat,
      defkf,
      serviceData: {
        userName:"",
        phone:"",
        msg:""
      },
      compNo: '',
      randomCont:-1,
    }
  },
  props: {
    from: {
      type: String
    }
  },
  mounted() {
    var that = this
    // that.from  表示从哪来
    that.$api['user/getCustomerInfoList']({}).then(res=>{
      if(res.data){
        console.log("123",res)
        var list = res.data
        // 拿到type
        const filterType = list.filter((item)=>{
          if(item['productType'] == that.from){
            if(item['userList'].length == 2){
              this.serviceData['userName'] = item['userList'][this.randomCont>0.5?1:0]["userName"]
              this.serviceData['phone'] = item['userList'][this.randomCont>0.5?1:0]["phone"]
              this.serviceData['productType'] = item["productType"]
              this.serviceData['url'] = item["gidMdk"]
            }else{
              this.serviceData['userName'] = item['userList'][0]["userName"]
              this.serviceData['phone'] = item['userList'][0]["phone"]
              this.serviceData['productType'] = item["productType"]
              this.serviceData['url'] = item["gidMdk"]
            }
          }
          return item['productType'] == that.from
        })
        // 获取签名
        that.$api['btlh/serviceGroupList']({}).then(res2=>{
          console.log("res2",res2);
          console.log("serviceData",serviceData.data)
          for(let i=0;i<err.data.length;i++){
            for(let j=0;j<err.data[i]['productType'].length;j++){
              if(err.data[i]['productType'][j] == this.serviceData.productType){
                this.serviceData.msg = err.data[i]['adv']
              }
            }
            // err.data[i]['productType'].map((item)=>{
            //   // console.log(item);
            //   // console.log(item == this.serviceData);
               
            // })
          }
        }).catch(err => {
          console.log('configError', err)
          for(let i=0;i<serviceData.data.length;i++){
            for(let j=0;j<serviceData.data[i]['productType'].length;j++){
              if(serviceData.data[i]['productType'][j] == this.serviceData.productType){
                this.serviceData.msg = serviceData.data[i]['adv']
              }
            }
            // err.data[i]['productType'].map((item)=>{
            //   // console.log(item);
            //   // console.log(item == this.serviceData);
               
            // })
          }
          console.log("this.serviceData",this.serviceData);
        })
      }
    })
    let state = localget('VUEX_STATE') || {}
    if (state.app && state.app.loginConfig) {
      this.compNo = state.app.loginConfig.by4
    }

    
  },
  methods: {
    random(){
      this.randomCont  = Math.random()
    },
    toWeChat(url){

      if(isH5()||isAndroid()){
        console.log(123);
        var ua = window.navigator.userAgent.toLowerCase()
        if(ua.match(/MicroMessenger/i) == 'micromessenger'){
          location.href = url }else {
          if(this.isWx){
            var iframe = document.createElement('iframe')
            iframe.src = url
            iframe.height=0
            iframe.width=0
            document.body.appendChild(iframe)
            iframe.onload=function(){
              console.log(arguments)
            }
          }else{
            /*
              visitorid参数，参数值为访客id
              visitorname参数，参数值为访客名称
              ctag参数，参数值为参数值为自定义传参
              gid:客服组id
            */
            // var href = url+"&visitorid="+empId+"&visitorname="+shortname+"-"+empName+"-"+phoneNumber+"&gid="+gidMdk+"&ctag="+corpNo
            // var href = url+"&visitorid="+empId+"&visitorname="+empName+"&ctag="+corpNo
            var iframe = document.createElement('iframe')
            iframe.src = url
            iframe.height=0
            iframe.width=0
            document.body.appendChild(iframe)
            iframe.onload=function(){
              console.log(arguments)
            }
          }
        }
      }else if(isIOS()){
        openWebview(url, 'towechat','','','',function(){
          setTimeout(function(){
            plus.webview.close('towechat')
          },5000)
        })
      }
    },
    call (telNum) {
      var iframe = document.createElement('iframe')
      iframe.src = `${'tel:'+telNum}`
      iframe.height=0
      iframe.width=0
      document.body.appendChild(iframe)
      iframe.onload=function(){
        console.log(arguments)
      }
      console.log('拨打电话' + telNum)
    },
  }
}
</script>

<style lang="less">
.imageStyle{
  width: .8rem;
}
.service-card-wrap{
  position: absolute;
  left: 0;
  right: 0;
  bottom: 42px;
  // bottom: -7px;
  padding: 0px 6px;
  // margin: 0 12px;
  margin-bottom: 10px;
  // background-color: #fff;
   transform: translateY(3px);
  .zskf {
    position: relative;
    background-color: #da0000;
    width: 80px;
    height: 20px;
    float: right;
    margin-right: 25px;
    margin-bottom: -10px;
    z-index: 5;
    text-align: center;
    color: #ffffff;
    font-size: 14px;
    line-height: 20px;
    border-bottom-right-radius:4px;
    border-bottom-left-radius:4px;
  }

  .triangle-bottomleft{
    height: 0px;
    width: 0px;
    border-bottom: 10px solid #a60007;
    border-right: 10px solid transparent;
    border-top: 10px solid transparent;
    border-left: 10px solid transparent;
    margin-bottom: -10px;
    float: right;
    transform: translateX(90px)translateY(-10px);

  }
}
.service-card-wrapTwo{
  position: absolute;
  left: 0;
  right: 0;
  // bottom: 50px;
  bottom: -7px;
  padding: 0px 6px;
  // margin: 0 12px;
  margin-bottom: 10px;
  // background-color: #fff;
  .zskf {
    position: relative;
    background-color: #da0000;
    width: 80px;
    height: 20px;
    float: right;
    margin-right: 25px;
    margin-bottom: -10px;
    z-index: 5;
    text-align: center;
    color: #ffffff;
    font-size:0.18rem;
    line-height: 20px;
    border-bottom-right-radius:4px;
    border-bottom-left-radius:4px;
  }

  .triangle-bottomleft{
    height: 0px;
    width: 0px;
    border-bottom: 10px solid #a60007;
    border-right: 10px solid transparent;
    border-top: 10px solid transparent;
    border-left: 10px solid transparent;
    margin-bottom: -10px;
    float: right;
    transform: translateX(90px)translateY(-10px);

  }
}

.profile {
  height: 1rem;
  width: 1rem;
}

.nameZskf {
  font-size: 0.27rem;
  font-weight: 400;
}

.typename {
  font-size: 0.2rem;
  font-weight: 600;
}

.qgehome {
  position: relative;
  padding: 30px 10px 10px;
}

.kflist {
  height: calc(104/375*100vw);
}

.flexbox{
  background:#fff;
  display: flex;
  align-items: center;

  img{
    align-items: center;
  }
}

</style>
